import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_COUPON = createActionTypes('CREATE_COUPON');
export const FETCH_COUPONS = createActionTypes('FETCH_COUPONS');
export const GET_COUPON = createActionTypes('GET_COUPON');
export const DELETE_COUPON = createActionTypes('DELETE_COUPON');
export const UPDATE_COUPON = createActionTypes('UPDATE_COUPON');
export const BOOKING_COUPON = createActionTypes('BOOKING_COUPON');